import { createApp, h } from 'vue'
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3'
import Button from './Vue/Utilities/Button.vue';
import BackgroundImage from './Vue/Utilities/BackgroundImage.vue';
import Burn from './Vue/Utilities/Burn.vue';
import SmoothLink from './Vue/Utilities/SmoothLink';
import SmoothLoader from './Vue/Utilities/SmoothLoader.vue';

const $ = window.jQuery;

window.wait = async function (ms) {
    return new Promise(resolve => {
        window.setTimeout(resolve, ms);
    });
}

window.prefersReducedMotion = () => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery || mediaQuery.matches) {
        return true;
    } else {
        return false;
    }
};

window.isMobileChrome = () => {
    const parser = new UAParser();
    const result = parser.getResult();
    return result.browser.name === 'Chrome' && result.device.type === 'mobile';
};

window.rand = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
};

$.fn.isInViewport = function(offset = 0) {

    var top_of_element = this.offset().top + offset;
    var bottom_of_element = this.offset().top + this.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        return true;
    } else {
        return false;
    }

};

createInertiaApp({
  resolve: name => require(`./Vue/${name}`),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .component('BackgroundImage', BackgroundImage)
      .component('Button', Button)
      .component('Burn', Burn)
      .component('SmoothLoader', SmoothLoader)
      .component('Link', SmoothLink)
      .mount(el)
  },
});

/*

window.shareToClipboard = async function() {
    let el = document.getElementById('urlSelector');
    el.select();
    document.execCommand('copy');
    $('.page-share .popper').removeClass('idle');
    $('.page-share .popper').addClass('popping');
    await window.wait(250);
    $('.page-share .popper').removeClass('popping');
    $('.page-share .popper').addClass('popped');
    await window.wait(250);
    $('.page-share .popper').removeClass('popped');
    $('.page-share .popper').addClass('idle');
};

// https://stackoverflow.com/questions/20791374/jquery-check-if-element-is-visible-in-viewport
$.fn.isInViewport = function(offset = 0) {

    var top_of_element = this.offset().top + offset;
    var bottom_of_element = this.offset().top + this.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        return true;
    } else {
        return false;
    }

};

$(document).ready(function() {


    // Fixed header
    // ============

    $(window).scroll(async function() {
        let distance = $(window).scrollTop();
        if (distance >= 40) {
            $('.sitewide-header').addClass('scrolled');
            $('.sitewide-header').removeClass('unscrolled');
            $('.sitewide-header nav').addClass('scrolled');
            $('.sitewide-header nav').removeClass('unscrolled');
            if ($('.sitewide-header').hasClass('light')) {
                await window.wait(100);
                $('.sitewide-header .logo img').attr('src', '/wp-content/themes/landslide/img/logo-white.png');
            }
        } else {
            $('.sitewide-header').removeClass('scrolled');
            $('.sitewide-header').addClass('unscrolled');
            $('.sitewide-header nav').removeClass('scrolled');
            $('.sitewide-header nav').addClass('unscrolled');
            if ($('.sitewide-header').hasClass('light')) {
                await window.wait(100);
                $('.sitewide-header .logo img').attr('src', '/wp-content/themes/landslide/img/logo-color.png');
            }
        }
    });


    // Popup
    // =====

    (async function() {

        if (!$('.popup').length) {
            return;
        }

        let cookie = $('.popup').data('cookie');

        if (prefersReducedMotion() || window.localStorage.getItem(cookie)) {
            $('.popup').remove();
            return;
        }

        $('.popup .closer').click(async () => {
            $('body, html').removeClass('overflow-hidden');
            $('.popup .backdrop').addClass('out');
            $('.popup .popup-body').addClass('out');
            await window.wait(300);
            $('.popup').remove();
            window.localStorage.setItem(cookie, 'closed');
        });

        await window.wait(3000);

        $('body, html').addClass('overflow-hidden');

        $('.popup').removeClass('unpopped');
        await window.wait(180);

        $('.popup .backdrop').removeClass('out');
        await window.wait(100);

        $('.popup .popup-body').removeClass('out');

    })();


    // Video Modal
    // ===========

    $('a.video-popup-trigger').each(function() {
        $(this).modaal({
            type: 'video',
            background: '#150051',
            overlay_opacity: 0.92
        });
    });


    // Site Alert
    // ==========

    (function() {

        if (!$('.site-alert').length) {
            return;
        }

        if (window.innerWidth < 768) {
            $('.sitewide-header').addClass('no-alert');
            $('.site-alert').remove();
            return;
        }

        let cookie = $('.site-alert').data('cookie');
        if (window.localStorage.getItem(cookie) === 'closed') {
            $('.sitewide-header').addClass('no-alert');
            $('.site-alert').remove();
            return;
        }

        $('.sitewide-header').addClass('with-alert');
        $('.site-alert').removeClass('hidden');

        $('.close-alert').click(async function() {
            window.localStorage.setItem(cookie, 'closed');
            $('.sitewide-header').removeClass('with-alert');
            $('.sitewide-header').addClass('no-alert');
            await window.wait(220);
            $('.site-alert').remove();
        });

    })();


    // Mobile Menu
    // ===========

    (function() {

        const parents = $('.mobile-menu nav > div > ul > li.menu-item-has-children');
        parents.each(function() {

            let toggler = $(`<button class="child-toggler mr-4 text-white"><i class="fas fa-caret-down text-xl"></i><span class="sr-only">Toggle child items</span></button>`);
            $(this).prepend(toggler);

            let parent = $(this);

            $(toggler).click(function() {
                let childMenu = parent.find('ul.sub-menu');
                childMenu.toggleClass('open');
                childMenu.slideToggle();
                $(this).toggleClass('open');
            });

        });

        function clickoffHandler() {
            $('.toggle-mobile-nav').toggleClass('open');
            $('body, html').toggleClass('overflow-hidden');
            $('#site-wrapper').toggleClass('show-nav');
            $('#site-canvas').off('click', clickoffHandler);
        }

        $('.toggle-mobile-nav').click(function() {
            $(this).toggleClass('open');
            $('body, html').toggleClass('overflow-hidden');
            $('#site-wrapper').toggleClass('show-nav');
            $('#site-canvas').on('click', clickoffHandler);
        });

        window.addEventListener('smoothLinkClicked', (e) => {
            if ($('html').hasClass('overflow-hidden')) {
                clickoffHandler();
            }
        });

    })();


    // Tweets
    // ======

    (async function() {

        if (!$('.latest-tweet').length) {
            return;
        }

        const tweetBox = (tweet) => {
            return `<p class="tweet-text font-body font-medium text-gray-800">${tweet.text}</p>
            <ul class="tweet-buttons flex -mx-1">
            <li class="px-1"><a target="_blank" href="https://twitter.com/intent/like?tweet_id=${tweet.id}"><i class="fas fa-heart" aria-hidden="true"></i><span class="sr-only">Like this Tweet</span></a></li>
            <li class="px-1"><a target="_blank" href="https://twitter.com/intent/retweet?tweet_id=${tweet.id}"><i class="fas fa-retweet" aria-hidden="true"></i><span class="sr-only">Like this Tweet</span></a></li>
            <li class="px-1"><a target="_blank" href="https://twitter.com/intent/tweet?in_reply_to=${tweet.id}"><i class="fas fa-reply" aria-hidden="true"></i><span class="sr-only">Like this Tweet</span></a></li>
            </ul>
            `;
        };

        let response = await fetch('/twitter/post-plus-tweet');
        response = await response.json();

        if (!response.length) {
            return;
        }

        $('.latest-tweet').each(function() {
            let html = tweetBox(response[0]);
            $(this).html(html);
        });

    })();


    // Google Translate
    // ================

    (function() {
        $('button.show-or-hide').click(function() {
            $(this).toggleClass('rounded');
            $(this).toggleClass('rounded-t');

            $('.language-button').toggleClass('opened');
            $('#google_translate_element').toggleClass('closed');
            $('#google_translate_element').addClass('opened');
        });
    })();


    // Load-in Animation
    // =================

    (function() {

        if (prefersReducedMotion()) {
            return;
        }

        const loaders = new Map();
        $('[data-loads]').each(function(i, el) {
            loaders.set(el, false);
        });

        $('[data-loads]').each(function(i, el) {

            let trigger = $(el).data('trigger')
                ? $('#' + $(el).data('trigger'))
                : $(el);

            let loader = $(el); // $(this);
            let delay = 50;
            if ($(el).data('delay')) {
                delay = delay + $(el).data('delay');
            }

            $(window).scroll(function() {
                if (!trigger.isInViewport() || loaders.get(el)) {
                    return;
                }
                loaders.set(el, true);
                window.setTimeout(() => {
                    loader.removeClass('out');
                    loader.addClass('in');
                }, delay);
            });

        });

        $(window).scroll();

    })();


    // External Links
    // ==============

    (function() {

        let hostname = window.location.hostname;
        $('a').each(function() {
            if ($(this).hasClass('modal-trigger')) {
                return;
            }
            if ($(this).hasClass('anchor-id')) {
                return;
            }
            let href = $(this).attr('href');
            if (href.indexOf('/') === 0) {
                return;
            }
            if (href.indexOf(hostname) === -1) {
                $(this).attr('target', '_blank');
            }
        });
    })();

});

*/